<template>
  <main class="container main-members-why">
    <section class="wellcome-section">
      <button class="btn outline">CESCO Members</button>
      <h1>Why CESCO <br class="mo_show" />Members</h1>
      <p>CESCO Members enhance visitor environments through sophisticated hygiene solutions managed by CESCO science.</p>
      <p class="description">
        Transform any business environment into a clean and safe space with CESCO Members,
        <br />
        ensuring customers always feel secure, wherever they are.
      </p>
    </section>

    <img :src="require(`@/assets/images/members/main_why${mobileCheck ? '_mo' : ''}.svg`)" class="main-img" alt="CESCO [Members] Why CESCO Members" />

    <section class="section members-why-1">
      <div class="contents-center">
        <h3 class="title-section">
          Trusted by 450,000 CESCO Members
          <br />
          Across South Korea
        </h3>

        <p class="description-section">
          CESCO has devoted nearly half a century to researching environmental hygiene and now stands <br class="pc_show" />
          as the leading comprehensive environmental hygiene management brand in South Korea, with <br class="pc_show" />
          about 450,000 active customers.
        </p>

        <div class="card-list">
          <div class="card-item card-item-1">
            <div>
              <h4>Customer Retention</h4>
              <p><b>Q.</b> How likely are you to continue using the current CESCO Members service?</p>
              <div class="tags">
                <span> # No Pests Or Bugs </span>
                <span> # Thorough Management </span>
                <span> # Effective Results </span>
                <span> # Excellent/Friendly Service From Staff </span>
              </div>
            </div>
            <img src="@/assets/images/members/card_item_pie_01.svg" alt="CESCO [Members] Why CESCO Members" />
          </div>
          <div class="card-item card-item-2">
            <div>
              <h4>Real Testimonials from CESCO Members</h4>
            </div>

            <swiper
              :slides-per-view="'auto'"
              :centered-slides="true"
              :loop="true"
              :autoplay="{
                delay: 2000,
                disableOnInteraction: false
              }"
              :modules="[Autoplay]"
              class="testimonials-swiper"
            >
              <swiper-slide class="testimonials-item">
                <h3>CKD Bio Ansan</h3>
                <img src="@/assets/images/members/star.svg" />
                <p>
                  First of all, I would like to express my gratitude to the CESCO employees. Despite an increase in demands since my representative
                  changed, you consistently perform pest control with a smile, never showing any irritation.
                </p>
              </swiper-slide>
              <swiper-slide class="testimonials-item">
                <h3>Real Sloth</h3>
                <img src="@/assets/images/members/star.svg" />
                <p>
                  Special thanks to Service Consultant Mr. Sung Joo Cho.
                  <br />
                  I operate a small caf_ in Gwangju, Gyeonggi. Despite the small size of my store, he is thorough in checking areas vulnerable to
                  pests.
                </p>
              </swiper-slide>
              <swiper-slide class="testimonials-item">
                <h3>Yangsan Branch) - Definitely leaving a review…</h3>
                <img src="@/assets/images/members/star.svg" />
                <p>
                  I have been a CESCO customer for a year and a half. During today's routine inspection, I realized I definitely needed to write a
                  review.
                </p>
              </swiper-slide>
              <swiper-slide class="testimonials-item">
                <h3>Oh My Cookie</h3>
                <img src="@/assets/images/members/star.svg" />
                <p>
                  I own a small cookie shop
                  <br />
                  in Hwaseong, Dongtan. Having opened last winter, we have now gone through our first spring and are approaching summer. The trees
                  surrounding the store,
                </p>
              </swiper-slide>
              <swiper-slide class="testimonials-item">
                <h3>Paris Baguette Review</h3>
                <img src="@/assets/images/members/star.svg" />
                <p>
                  When discussing CESCO with other nearby store owners, I find their opinions are very divided. Some say it's not worth the cost,
                  while others say it's essential…
                </p>
              </swiper-slide>
              <swiper-slide class="testimonials-item">
                <h3>Lotte Department Store Daejeon Branch</h3>
                <img src="@/assets/images/members/star.svg" />
                <p>
                  I am deeply grateful to all CESCO employees. You have put in a lot of effort since dawn today to conduct disinfection operations.
                  With the rise of COVID-19, yours appears to be one of the busiest professions.
                </p>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </section>

    <section class="section members-why-2">
      <div class="contents-center">
        <h3 class="title-section">
          Trustworthiness of
          <br />
          CESCO Members Mark
        </h3>
        <p class="description-section">
          Many businesses already display the Members mark to
          <br class="pc_show" />
          signal to customers that they operate clean establishments.
        </p>
        <div class="member-card">
          <img src="@/assets/images/members/member_img.png" class="member-img" />

          <div class="member-info">
            <img class="member-logo" src="@/assets/images/members/member_logo_01.png" alt="" />
            <h3 class="member-title">Blue CESCO Members Mark</h3>
            <p class="member-description">
              A certification mark attached to establishments managed with 2,193 scientifically tailored pest control solutions.
            </p>
          </div>

          <div class="member-info">
            <img class="member-logo" src="@/assets/images/members/member_logo_02.png" alt="" />
            <h3 class="member-title">White CESCO Members Mark</h3>
            <p class="member-description">
              A certification mark attached to establishments managed with comprehensive custom solutions for food processing, distribution, storage,
              and cooking.
            </p>
          </div>
        </div>
        <div class="mark-info">
          <h3>
            CESCO members are recognized for providing a fresh, safe, and clean
            <br class="pc_show" />
            environment, attracting more visitors and increasing sales.
          </h3>
          <img v-if="mobileCheck" src="@/assets/images/members/mark_info.png" alt="" />
        </div>
      </div>
    </section>

    <section class="section members-why-3">
      <div class="contents-center">
        <h3 class="title-section center">
          Impact of <br class="mo_show" />
          the Members Mark
        </h3>
        <p class="description-section center">
          More than 450,000 CESCO Members have reported high satisfaction, noting over 97%
          <br />
          improvement in perceived cleanliness and a more than 70% increase in order volume after
          <br />
          attaching the Members mark.
        </p>
        <div class="card-list">
          <div class="card-item card-item-1">
            <div>
              <h4>CESCO Members Mark On App Platforms</h4>
              <p>
                The CESCO Members online mark can be seen when searching on platforms such as Baedal Minjok and Yogiyo- Korea’s biggest delivery
                service platforms, as well as Naver- the largest search engine in Korea.
              </p>
            </div>
            <img src="@/assets/images/members/online_info.png" />
          </div>
          <div class="card-item card-item-2">
            <div>
              <h4>Members Mark Impacts</h4>
              <p>
                <b>Q.</b> Does the CESCO Members mark influence how often customers visit your store?
                <br />
                <span class="blue">
                  <b>A.</b>
                  “Yes, it affects the number of customers who visit my store.”
                </span>
              </p>
            </div>
            <img src="@/assets/images/members/card_item_pie_02.svg" />
          </div>
          <div class="card-item card-item-3">
            <div>
              <h4>Consumer Perceptions of the Members Mark</h4>
              <p>
                <b>Q.</b> Do you think establishments with the mark are more hygienic than those without?
                <br />
                <span class="blue">
                  <b>A.</b>
                  Over 97% responded "Establishments with the Members mark are more hygienic."
                </span>
              </p>
            </div>
            <img src="@/assets/images/members/card_item_pie_03.svg" />
          </div>
          <div class="card-item card-item-4">
            <div>
              <h4>Order Volume Following the Display of the Members Mark</h4>
              <p>
                <b>Q.</b> Did sales increase after displaying the CESCO Members mark?
                <br />
                <span class="blue">
                  <b>A.</b>
                  An average increase of 70% in order volume was noted after the mark was displayed.
                </span>
              </p>
            </div>
            <img src="@/assets/images/members/card_item_pie_04.svg" />
          </div>
        </div>
      </div>
    </section>

    <section class="section members-why-4">
      <div class="contents-center">
        <h3 class="title-section">
          CESCO’s Support for Display Materials related to
          <br class="pc_show" />
          Hygiene Certification
        </h3>
        <p class="description-section">
          CESCO provides materials that promote hygiene certification. This support helps businesses
          <br class="pc_show" />
          gain recognition as safer and more hygienic establishments, thereby safeguarding against
          <br class="pc_show" />
          potential health hazards.
        </p>
        <img src="@/assets/images/members/display_info.svg" alt="CESCO [Members] Why CESCO Members" />
      </div>
    </section>

    <section class="member-footer">
      <h2>
        CESCO Members Ensure Trust
        <br />
        Among Visitors
      </h2>
      <p>
        CESCO Members enjoy unique benefits not offered by any other
        <br />
        environmental hygiene company, underscoring the public's trust in CESCO.
      </p>
      <a class="btn" href="mailto:'sj.kim@cesco.co.kr'"> Send Email </a>
    </section>
  </main>
</template>

<script setup>
import { inject } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay } from 'swiper/modules'
import { useMeta } from 'vue-meta'

const mobileCheck = inject('mobileCheck')

useMeta({
  title: 'CESCO - Why CESCO Members',
  meta: [
    {
      vmid: 'description',
      name: 'description',
      content: 'Why CESCO Members? CESCO Members enhance visitor environments through sophisticated hygiene solutions managed by CESCO science.'
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/members-why.scss';
</style>
